import template from './surveys_setup_add.html';
import tr from '../../lib/default-translator.js';
import ClassicEditor from '../../lib/ckeditor/build/ckeditor.js';
import ClassicEditorConfig from '../../lib/ClassicEditorConfig.js';

class SurveySetupAddViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.surveys = ko.observableArray();
		this.survey_items = ko.observableArray();
		this.survey_input_types = ko.observableArray();
		this.survey_items_options = ko.observableArray();
		this.survey_items_range = ko.observableArray();
		this.anonymous = ko.observable();
		this.recipients = ko.observableArray([]);
		this.employee_group = ko.observableArray();
		this.departments = ko.observableArray();
		this.check_is_public = ko.observable(false);
		this.send_everyone_check = ko.observable(false);
		this.start_date = ko.observable(new Date(moment().format('YYYY-MM-01')).toJSON().slice(0, 10));
		this.end_date = ko.observable(new Date(moment().format('YYYY-MM-') + moment().daysInMonth()).toJSON().slice(0, 10));
		this.survey_document = ko.observableArray([]);
		this.has_attachment = ko.observable(false);
		this.file_name = ko.observable();
		this.survey_id = ko.observable();
		this.all_recipients = ko.observableArray([]);
		this.search_string = ko.observable('');
		this.editor = ko.observable();
		this.selected_recipients = ko.observableArray([]);
		this.editing = ko.observable(false);
		this.description = ko.observable('');
		this.creating = ko.observable(false);
		this.title = ko.observable('');

		let check_file_input = setInterval(() => {
			let file_input = document.getElementById('batch_file');
			let upload_input = document.getElementById('upload_input');

			if (!this.anonymous())
			{
				if (file_input && upload_input)
					{
						file_input.addEventListener('change', (event) => {
							upload_input.value = event.target.value.replace('C:\\fakepath\\', '');
							this.has_attachment(true);
						});
		
						clearInterval(check_file_input); // Stop checking once found
					}
					else
						console.log('File input or upload input element not found yet');
			}
		}, 1000);

		let startTimeout = null;
		let endTimeout = null;

		this.start_date.subscribe((val) => {
			clearTimeout(startTimeout);
			startTimeout = setTimeout(() => {
				if (this.start_date() >= this.end_date()) {
					this.end_date(val);
				}
			}, 1000);
		});

		this.end_date.subscribe((val) => {
			clearTimeout(endTimeout);
			endTimeout = setTimeout(() => {
				if (this.start_date() >= this.end_date()) {
					this.start_date(val);
				}
			}, 1500);
		});

		this.search_string.subscribe((val) => {
			this.dialog.update_search_data();
		});
	}

	select_recipient(data)
	{
		this.selected_recipients.push(data);
		this.all_recipients.removeAll();
		this.search_string('');
		this.recipients.push(data.employee_id);
	}

	remove_recipient(data)
	{
		this.selected_recipients.remove(data);
		this.recipients.remove(data.employee_id);
		this.search_string('');
	}

	close()
	{
		this.dialog.close();
	}

	async save_survey()
	{
		let data;
		if (this.anonymous())
		{
			data = {
				survey_id: this.survey_id(),
				title: document.getElementById('txtTitle').value,
				content: this.dialog.editor.getData(),
				sub_title: document.getElementById('txtSub_Title').value,
				start_date: document.getElementById('txtStartDate').value,
				end_date: document.getElementById('txtEndDate').value,
				description: this.dialog.editor.getData(),
				active: true,
				public: true,
				emp_not_log_in: false
			};
		}
		else
		{
			data = {
				survey_id: this.survey_id(),
				title: document.getElementById('txtTitle').value,
				content: this.dialog.editor.getData(),
				sub_title: document.getElementById('txtSub_Title').value,
				start_date: document.getElementById('txtStartDate').value,
				end_date: document.getElementById('txtEndDate').value,
				description: this.dialog.editor.getData(),
				active: true,
				public: this.check_is_public(),
				employees: this.recipients(),
				send_to_everyone: this.send_everyone_check(),
				emp_not_log_in: true
			};
		}

		if (data.survey_id == '')
			data.survey_id = null;

		// Some validation before saving
		let valid = true;
		let msg = '';

		if (!data.title.trim())
		{
			valid = false;
			msg = tr('Please enter a survey title before saving.');
		}
		else if (!data.sub_title.trim())
		{
			valid = false;
			msg = tr('Please enter a survey sub-title before saving.');
		}
		else if ((!data.start_date) || (!data.end_date))
		{
			valid = false;
			msg = tr('Please enter a start and end date for the survey.'); 
		}
		else if (!this.anonymous())
		{
			if (!data.send_to_everyone && data.employees.length == 0)
			{
				valid = false;
				msg = tr('For a survey that is not for everyone recipients must be specified.');
			}
		}

		if (valid)
		{
			let res = await Grape.fetches.postJSON('/surveys/save_survey', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					// UPLOAD FILE
					if (this.has_attachment() == true)
					{
						let formData = new FormData($('#batchuploadform')[0]);
						if (document.getElementById('batch_file').files[0])
						{
							if (document.getElementById('batch_file').files[0].size > 20000000)
							{
								Grape.alerts.alert({type: 'error', message: tr('File size exceeds the maximum limit of 20MB', 'File size exceeds the maximum limit of 20MB'), title: tr('Error', 'Error')});
								formData.append('abort_upload', 'true');
								return;
							}
						}
						/* */
						formData.append('survey_id', res.survey_id);
						formData.append('filename', $('#upload_input').val());

						let xhr = new XMLHttpRequest();
						xhr.open('post', '/surveys/upload_document', true);
						xhr.setRequestHeader('Accept', 'application/json');
						xhr.send(formData);
					}

					Grape.alerts.alert({type: 'success', message: tr('Successfully saved survey.', 'Successfully saved survey.'), title: tr('Success', 'Success')});
					this.dialog.close();
				}
				else if (res.status == 'ERROR')
				{
					Grape.alerts.apiError(res);
					this.dialog.updateData();
				}
				else if (res.error)
				{
					Grape.alerts.alert({ type: 'error', message: res.error, title: tr('Error', 'Error') });
					this.dialog.updateData();
				}
				else
					Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
			}
		}
		else
			Grape.alerts.alert({type: 'error', message: msg, title: tr('Validation Error')});
	}

	async add_group(v, e)
	{
		if (v.recipients)
		{
			for (let i = 0; i < v.recipients.length; i++)
			{
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'employee',
					limit: 1000000,
					filter: [{ value: v.recipients[i].employee_id, operand: '=', field: 'employee_id' }]
				});

				if (res)
				{
					if (res.records != null)
					{
						for (let i = 0; i < res.records.length; i++)
						{
							let employee_id = parseInt(res.records[i].employee_id);

							// Check if the employee is already in the selected_recipients
							let already_selected = this.selected_recipients().some(recipient => recipient.employee_id === employee_id);

							// If not already selected, fetch the employee details and add them
							if (!already_selected)
							{
								let result = await Grape.fetches.getJSON('/api/record', {
									table: 'employee',
									limit: 1000000, 
									filter: [{ value: employee_id, op: '=', field: 'employee_id' }]
								});

								if (result.records != null && result.records.length > 0)
								{
									let name = res.records[0].firstname + ' ' + res.records[0].surname + ' (' + res.records[0].id_number + ')';
									let id = parseInt(res.records[0].employee_id);
									this.recipients.push(res.records[0].employee_id);
									this.selected_recipients.push({name: name, employee_id: id});
								}
							}
						}
					}
				}
			}
		}
	}

	async add_department_group(v)
	{
		// Populate recipients text box with exitsting data
		let res = await Grape.fetches.getJSON('/api/record', {
			table: 'v_active_employees_department',
			schema: 'savanna', limit: 1000000,
			filter: [{ value: v.department_id, op: '=', field: 'department_id' }]
		}); 

		if (res.records != null)
		{
			for (let i = 0; i < res.records.length; i++)
			{
				let employee_id = parseInt(res.records[i].employee_id);

				// Check if the employee is already in the selected_recipients
				let already_selected = this.selected_recipients().some(recipient => recipient.employee_id === employee_id);

				// If not already selected, fetch the employee details and add them
				if (!already_selected)
				{
					let result = await Grape.fetches.getJSON('/api/record', {
						table: 'employee',
						limit: 1000000, 
						filter: [{ value: employee_id, op: '=', field: 'employee_id' }]
					});

					if (result.records != null && result.records.length > 0)
					{
						let name = result.records[0].firstname + ' ' + result.records[0].surname + ' (' + result.records[0].id_number + ')';
						let id = parseInt(result.records[0].employee_id);

						this.recipients.push(id);
						this.selected_recipients.push({name: name, employee_id: id});
					}
				}
			}
		}
	}
}

class SurveySetupAddPage
{
	constructor (bindings)
	{
		this.viewModel = new SurveySetupAddViewModel(this);
		this.bindings = bindings;
		this.viewModel.survey_id(bindings.survey_id);
		this.viewModel.anonymous(bindings.anonymous);
	}

	async init()
	{
		// Populate employee group fields
		try {
			let options = {
				table: 'v_employee_group',
				schema: 'savanna',
				limit: 1000000
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status !== 'ERROR')
				this.viewModel.employee_group(res.records);
			else
				throw new Error(res.message || res.code);
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		// Populate department fields
		try {
			let options = {
				table: 'v_department_company',
				schema: 'savanna',
				limit: 10000,
				sortfield: 'department',
				sortorder: 'ASC'
			}

			let res = await Grape.fetches.getJSON('/api/record', options);
			if (res.status !== 'ERROR')
			{
				if (res.records)
				{
					for (let i = 0; i < res.records.length; i++)
						res.records[i].name = res.records[i].department + ' (' + res.records[i].company + ')';

					this.viewModel.departments(res.records);
				}
			}
			else
				throw new Error(res.message || res.code);
		} catch (error) {
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
			console.error(error)
		}

		// new survey
		if (this.bindings.data == undefined)
		{
			this.viewModel.editing(false);
			this.viewModel.title('Create Survey');
			this.viewModel.creating(true);
			this.viewModel.surveys([
				{
					'survey_id': 0,
					'title': '',
					'sub_title': '',
					'content': '',
					'start_date': moment().format('YYYY-MM-DD'),
					'end_date': moment().format('YYYY-MM-DD'),
					'public': true
				}
			]);

			this.viewModel.survey_items([
				{ 'survey_id': 0,
					'survey_items_id': 0,
					'question': '',
					'input_type': '' }
			]);

			// SURVEY INPUT TYPES
			try {
				let options = {
					table: 'survey_input_types', 
					limit: 1000000
				};

				let res = await Grape.fetches.getJSON('/api/record', options);
				if (res.status !== 'ERROR')
					this.viewModel.survey_input_types(res.records);
				else
					throw new Error(res.message || res.code);
			} catch (error) {
				Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
				console.error(error)
			}

			this.viewModel.check_is_public(true);
			this.viewModel.survey_id(0);
		}
		else
		{
			this.viewModel.editing(true);
			this.viewModel.title('Edit Survey');
			this.viewModel.creating(false);
			this.viewModel.survey_id(this.bindings.data.survey_id);
			this.viewModel.description(this.bindings.data.description || ' ');
			// SURVEY INPUT TYPES
			try {
				let options = {
					table: 'survey_input_types', 
					limit: 1000000
				};

				let res = await Grape.fetches.getJSON('/api/record', options);
				if (res.status !== 'ERROR')
					this.viewModel.survey_input_types(res.records);
				else
					throw new Error(res.message || res.code);
			} catch (error) {
				Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
				console.error(error)
			}

			try {
				let options = {
					table: 'v_surveys_list',
					schema: 'savanna',
					limit: 1000000,
					filter: [{ value: this.bindings.data.survey_id, op: '=', field: 'survey_id' }]
				};
				
				let res = await Grape.fetches.getJSON('/api/record', options);
				if (res.status !== 'ERROR' && res.records.length > 0){
					this.viewModel.surveys(res.records);
					const s = res.records[0];
					if (s.start_date) this.viewModel.start_date(moment(s.start_date).format('YYYY-MM-DD'));
					if (s.end_date)   this.viewModel.end_date(moment(s.end_date).format('YYYY-MM-DD'));


				}

				if (res.status !== 'ERROR')
				{
					this.viewModel.check_is_public(res.records[0].public);

					// Populate recipients text box with existing data
					if (res.records[0].recipients !== null)
					{
						for (let i = 0; i < res.records[0].recipients.length; i++)
						{
							let emp = await Grape.fetches.getJSON('/api/record', { 
								table: 'employee',
								limit: 1000000, 
								filter: [{
									value: res.records[0].recipients[i].employee_id,
									operand: '=',
									field: 'employee_id'
								}]
							});

							if (emp.records != null)
							{
								let names = emp.records[0].firstname + ' ' + emp.records[0].surname + ' (' + emp.records[0].id_number + ')';
								let ids = emp.records[0].employee_id
								this.viewModel.recipients.push(emp.records[0].employee_id);
								this.viewModel.selected_recipients.push({name: names, employee_id: ids});
							}
						}
					}
				}
			} catch (error) {
				Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
				console.error(error)
			}

			// SURVEY ITEMS
			try {
				let options = {
					table: 'survey_items',
					limit: 1000000,
					filter: [{
						value: this.bindings.data.survey_id,
						operand: '=',
						field: 'survey_id'
					},{
						value: true,
						operand: '=',
						field: 'active'
					}]
				}

				let res = await Grape.fetches.getJSON('/api/record', options);
				if (res.status !== 'ERROR')
					this.viewModel.survey_items(res.records);
				else
					throw new Error(res.message || res.code);
			} catch (error) {
				Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
				console.error(error)
			}

			// GET DOCUMENT
			try {
				let res = await Grape.fetches.getJSON('/surveys/get_document/', { survey_id: this.bindings.data.survey_id });
				if (res.status !== 'ERROR' )
				{
					if (res.length > 0)
					{
						this.viewModel.survey_document(res);
						this.viewModel.has_attachment(true);
						this.viewModel.file_name(res[0].filename);
						$('#upload_input').val(res[0].filename);
					}
				}
				else
					throw new Error(res.message || res.code);
			} catch (error) {
				Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
				console.error(error)
			}
		}

		this.enable_ckeditor();
	}

	async enable_ckeditor()
	{
		// load the ckeditor
		if (!this.editor)
			ClassicEditor.create(document.getElementById('description_editor'),
				Object.assign({}, ClassicEditorConfig, {
					height: '20em',
					toolbar: {
						items: [ '|', 'bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', '|', 'removeFormat', '|', 'Link' ,'|',  'undo', 'redo' ]
					},
				})
			).then((editor) => {
				this.editor = editor;
				this.editor.setData(this.viewModel.description());
			}).catch((err) => {
				console.error(err);
			});
	}

	async update_search_data()
	{
		let options = {
			table: 'employee',
			limit: 1000000,
			filter_join: 'OR',
			filter: []
		}

		//Search and get data for adding manager
		if (this.viewModel.search_string() && this.viewModel.search_string() != '')
		{
			options.filter.push({
				field: 'firstname',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`
			})

			options.filter.push({
				field: 'surname',
				operand: 'ILIKE',
				value: `%${this.viewModel.search_string()}%`
			})

			let result = await Grape.fetches.getJSON('/api/record', options);
			if (result.status != 'ERROR')
			{

				if (result.records != null)
				{
					let selectedIds = this.viewModel.selected_recipients().map(recipient => recipient.employee_id);
					let filteredRecords = result.records.filter(record => !selectedIds.includes(record.employee_id));
	
					let employees = filteredRecords.map((emp) => ({
						name: emp.firstname + ' ' + emp.surname + ' (' + emp.id_number + ')',
						employee_id: emp.employee_id
					}));
					this.viewModel.all_recipients(employees);
				}
			}
		}
		else
			this.viewModel.all_recipients([]);
	}
}

export default {
	name: 'SurveySetupAdd',
	dialog_class: SurveySetupAddPage,
	template: template,
	template_filename: 'translation/dialogs/surveys_setup_add',
	provider: 'ps'
};
